import PropTypes from 'prop-types';
import React from 'react';
import { localize } from './date-format';
import {
  revisionStatusInlineText,
  revisionStatusText,
  revisionStatusTitle
} from './recordRevisionStatusHelpers';

const RecordRevisionStatus = ({
  record,
  variant = 'footnote',
  className,
  recordLabel = 'record'
}) => {
  const title = revisionStatusTitle(record, localize, recordLabel);

  if (variant === 'inline') {
    return (
      <span
        className={
          className ?? 'record-revision-status record-revision-status--inline'
        }
        title={title}
      >
        {' · '}
        {revisionStatusInlineText(record)}
      </span>
    );
  }

  return (
    <p
      className={
        className ??
        'record-revision-status record-revision-status--below-panel'
      }
      title={title}
    >
      {revisionStatusText(record, localize, recordLabel)}
    </p>
  );
};

RecordRevisionStatus.propTypes = {
  record: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['inline', 'footnote']),
  className: PropTypes.string,
  recordLabel: PropTypes.string
};

export default RecordRevisionStatus;
